
import { useState, useEffect } from 'react';
import Button from '../base/Button';
import WhiteLogo from '../../assests/images/white.png';
import DarkLogo from '../../assests/images/dark.png';
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src={isScrolled 
                ? DarkLogo
                : WhiteLogo
              }
              alt="Roaffees - Brewing as an Artform" 
              className="h-12 w-auto transition-opacity duration-300"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-stone-700 hover:text-[#4F301F]' : 'text-white hover:text-stone-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('cafe')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-stone-700 hover:text-[#4F301F]' : 'text-white hover:text-stone-300'
              }`}
            >
              Café
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-stone-700 hover:text-[#4F301F]' : 'text-white hover:text-stone-300'
              }`}
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-stone-700 hover:text-[#4F301F]' : 'text-white hover:text-stone-300'
              }`}
            >
              Reviews
            </button>
            <button
              onClick={() => scrollToSection('location')}
              className={`px-4 py-2 text-sm rounded-md font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                isScrolled 
                  ? 'bg-[#4F301F] text-white hover:bg-[#3d2518]' 
                  : 'bg-white text-[#4F301F] hover:bg-stone-100'
              }`}
            >
              Visit Us
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-stone-900' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-4 px-4">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="text-stone-700 hover:text-[#4F301F] font-medium transition-colors text-left cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('cafe')}
                className="text-stone-700 hover:text-[#4F301F] font-medium transition-colors text-left cursor-pointer"
              >
                Café
              </button>
              <button
                onClick={() => scrollToSection('why-us')}
                className="text-stone-700 hover:text-[#4F301F] font-medium transition-colors text-left cursor-pointer"
              >
                Why Us
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-stone-700 hover:text-[#4F301F] font-medium transition-colors text-left cursor-pointer"
              >
                Reviews
              </button>
              <Button size="sm" className="cursor-pointer w-full" onClick={() => scrollToSection('location')}>
                Visit Us
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
